/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Permission_Badge_InstallInputs */

const en_agent_authorization_permission_badge_install = /** @type {(inputs: Agent_Authorization_Permission_Badge_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request the official Seek AI badge snippet for your footer`)
};

const zh_agent_authorization_permission_badge_install = /** @type {(inputs: Agent_Authorization_Permission_Badge_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取官方 Seek AI footer 徽章代码`)
};

/**
* | output |
* | --- |
* | "Request the official Seek AI badge snippet for your footer" |
*
* @param {Agent_Authorization_Permission_Badge_InstallInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_permission_badge_install = /** @type {((inputs?: Agent_Authorization_Permission_Badge_InstallInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Permission_Badge_InstallInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_permission_badge_install(inputs)
	return zh_agent_authorization_permission_badge_install(inputs)
});
export { agent_authorization_permission_badge_install as "agent.authorization.permission.badge_install" }